// Replay for story scenes that play once in view: after `runMs` the scene rests and a Replay
// button shows; replaying bumps `runKey`, which the scene binds as the :key of its animated
// stage so the CSS animations start again. `running` comes from useMotionInView, so with
// reduce-motion on the scene never runs and the button never shows.
export function useStoryReplay(running, runMs) {
  const runKey = ref(0);
  const canReplay = ref(false);
  let timer = null;

  const rest = () => {
    clearTimeout(timer);
    canReplay.value = false;
    timer = setTimeout(() => { canReplay.value = true; }, runMs);
  };
  watch(running, (on) => on && rest());
  const replay = () => {
    runKey.value += 1;
    rest();
  };
  onBeforeUnmount(() => clearTimeout(timer));

  return { runKey, canReplay, replay };
}
